export enum PREAVIS {
    SET_MODAL = 'SET_MODAL',
    SET_LOADING_LIST = 'SET_LOADING_LIST',
    SET_SUBMITTING = 'SET_SUBMITTING',
    SET_ERROR = 'SET_ERROR',
    SET_LIST = 'SET_LIST',
    ADD_ITEM = 'ADD_ITEM',
    UPDATE_ITEM = 'UPDATE_ITEM',
    REMOVE_ITEM = 'REMOVE_ITEM',
    SET_FILTERS = 'SET_FILTERS',
    SET_SORT = 'SET_SORT',
    SET_SELECTED_ID = 'SET_SELECTED_ID',
    RESET = 'RESET',
    SET_CREATE_DIRECT = 'SET_CREATE_DIRECT',
    SET_PREAVIS_SITE = 'SET_PREAVIS_SITE',
}
